import React, { useEffect, useState, useContext } from "react";
import {getTheme} from "../theme.jsx";
import { makeStyles } from "@mui/styles";
import { toast } from 'react-toastify';
import { Context } from "../context/ContextApi.jsx";
import {
  Tooltip,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Checkbox,
  Select,
  MenuItem,
  Button,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  DialogTitle,
} from "@mui/material";

import AvatarEditor from "react-avatar-editor";


import {
  AddAPhotoOutlined as AddAPhotoOutlinedIcon,
  ZoomInOutlined as ZoomInOutlinedIcon,
  ZoomOutOutlined as ZoomOutOutlinedIcon,
  Loop as LoopIcon,
  AddPhotoAlternate as AddPhotoAlternateIcon,
} from "@mui/icons-material";

import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Save as SaveIcon,
} from "@mui/icons-material";

const useStyles = makeStyles({
  notchedOutline: {
    borderColor: "#2e9fda !important",
  },
});

const defaultImage = "data:image/png;base64,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";

const OrgHeader = (props) => {
  const {
    userdata,
    selectedOrganization,
    setSelectedOrganization,
    globalUrl,
    isCloud,
    adminTab,
    handleEditOrg,
    isEditOrgTab,
    serverside,
  } = props;

  const classes = useStyles();

  var upload = "";
  const defaultBranch = "master";
  const [orgName, setOrgName] = React.useState(selectedOrganization.name);
  const [orgDescription, setOrgDescription] = React.useState(
    selectedOrganization.description
  );

  const { themeMode } = useContext(Context)
  const {theme} = getTheme(themeMode)

  const [file, setFile] = React.useState("");
  const [fileBase64, setFileBase64] = React.useState(
    selectedOrganization.image
  );
  useEffect(() => {
    if (selectedOrganization.image !== undefined && selectedOrganization.image !== null && selectedOrganization.image.length > 0) {
      setFileBase64(selectedOrganization.image);
      setFile(selectedOrganization.image);
    }
  }, [selectedOrganization]);

  const removeImage = () => {
    setFile("");
    setFileBase64("");
    setCroppedData(defaultImage);
    handleEditOrg(
      orgName,
      orgDescription,
      selectedOrganization.id,
      defaultImage,
      {
        app_download_repo: selectedOrganization?.defaults?.app_download_repo,
        app_download_branch: selectedOrganization?.defaults?.app_download_branch,
        workflow_download_repo: selectedOrganization?.defaults?.workflow_download_repo,
        workflow_download_branch: selectedOrganization?.defaults?.workflow_download_branch,
        notification_workflow: selectedOrganization?.defaults?.notification_workflow,
        documentation_reference: selectedOrganization?.defaults?.documentation_reference,
        workflow_upload_repo: selectedOrganization?.defaults?.workflow_upload_repo,
        workflow_upload_branch: selectedOrganization?.defaults?.workflow_upload_branch,
        workflow_upload_username: selectedOrganization?.defaults?.workflow_upload_username,
        workflow_upload_token: selectedOrganization?.defaults?.workflow_upload_token,
        newsletter: selectedOrganization?.defaults?.newsletter,
        weekly_recommendations: selectedOrganization?.defaults?.weekly_recommendations,
      },
      {
        sso_entrypoint: selectedOrganization?.sso_config?.sso_entrypoint,
        sso_certificate: selectedOrganization?.sso_config?.sso_certificate,
        client_id: selectedOrganization?.sso_config?.client_id,
        client_secret: selectedOrganization?.sso_config?.client_secret,
        openid_authorization: selectedOrganization?.sso_config?.openid_authorization,
        openid_token: selectedOrganization?.sso_config?.openid_token,
        SSORequired: selectedOrganization?.sso_config?.SSORequired,
        auto_provision: selectedOrganization?.sso_config?.auto_provision,
      },
      [],
    )
  };

  const surfaceColor = "#FFFFFF"
  const inputColor = "#FFFFFF"

  const bodyDivStyle = {
    margin: "auto",
    width: "900px",
  };

  const appIconStyle = {
    marginLeft: "5px",
  };

  const dividerStyle = {
    marginBottom: "10px",
    marginTop: "10px",
    height: "1px",
    width: "100%",
    backgroundColor: "grey",
  };

  if (file !== "") {
    const img = document.getElementById("logo");
    var canvas = document.createElement("canvas");
    canvas.width = 174;
    canvas.height = 174;
    var ctx = canvas.getContext("2d");

    img.onload = function () {
      // img, x, y, width, height
      //ctx.drawImage(img, 174, 174)
      //console.log("IMG natural: ", img.naturalWidth, img.naturalHeight)
      //ctx.drawImage(img, 0, 0, 174, 174)
      ctx.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        0,
        0,
        canvas.width,
        canvas.height
      );

      const canvasUrl = canvas.toDataURL();
      if (canvasUrl !== fileBase64) {
        setFileBase64(canvasUrl);
        selectedOrganization.image = canvasUrl;
        setSelectedOrganization(selectedOrganization);
      }
    };
  }


  var image = "";
  const editHeaderImage = (event) => {
    const file = event.target.value;
    const actualFile = event.target.files[0];
    const fileObject = URL.createObjectURL(actualFile);
    setFile(fileObject);
  };

  //console.log("USER: ", userdata)
  const orgSaveButton = (
    <Tooltip title="Save any unsaved data" placement="bottom">
      <Button
        style={{ width: 150, height: 55, flex: 1 }}
        variant="outlined"
        color="primary"
        disabled={
          userdata === undefined || userdata === null || userdata.admin !== "true"
        }
        onClick={() =>
          handleEditOrg(
            orgName,
            orgDescription,
            selectedOrganization.id,
            selectedOrganization.image,
            {},
            {},
            [],
          )
        }
      >
        <SaveIcon />
      </Button>
    </Tooltip>
  );

  const [imageUploadError, setImageUploadError] = React.useState("");
  const [openImageModal, setOpenImageModal] = React.useState(false);
  const [scale, setScale] = React.useState(1);
  const [rotate, setRotation] = React.useState(0);
  const [disableImageUpload, setDisableImageUpload] = React.useState(true);
  const [croppedData, setCroppedData] = React.useState(defaultImage);
  const [imageData, setImageData] = useState(selectedOrganization?.image?.lenth > 0 ? selectedOrganization?.image : defaultImage)

  React.useEffect(() => {
    if (file.length > 0) {
      setCroppedData(file);
    } else if (fileBase64 !== undefined && fileBase64 !== null && fileBase64.length > 0) {
      setCroppedData(fileBase64);
    } else {
      setCroppedData(defaultImage);
    }

    if((imageData !== selectedOrganization?.image) && selectedOrganization?.image?.length > 0){
      setImageData(selectedOrganization?.image)
    }
  }, [selectedOrganization, file]);


  const alternateImg = (
    <AddPhotoAlternateIcon
      style={{
        maxWidth: 174,
        maxHeight: 174,
        minWidth: 174,
        minHeight: 174,
        flex: "1",
        display: "flex",
        flexDirection: "row",
        margin: "auto",
        marginTop: 30,
        marginLeft: 40,
      }}
      onClick={() => {
        upload.click();
      }}
    />
  );

  const zoomIn = () => {
    setScale(scale + 0.1);
  };

  const zoomOut = () => {
    setScale(scale - 0.1);
  };

  const rotation = () => {
    setRotation(rotate + 10);
  };

  const onPositionChange = () => {
    setDisableImageUpload(false);
  };

  const onCancelSaveAppIcon = () => {
    setOpenImageModal(false);
    setImageUploadError("");
  };

  let editor;
  const setEditorRef = (imgEditor) => {
    editor = imgEditor;
  };


  const onSaveAppIcon = () => {
        const canvas = editor.getImageScaledToCanvas();
        const newImageData = canvas.toDataURL();
        setCroppedData(newImageData);  // Update croppedData with the new image data
        setOpenImageModal(false);
        setDisableImageUpload(true);
        handleEditOrg(
          orgName,
          orgDescription,
          selectedOrganization.id,
          newImageData,
          {
            app_download_repo: selectedOrganization?.defaults?.app_download_repo,
            app_download_branch: selectedOrganization?.defaults?.app_download_branch,
            workflow_download_repo: selectedOrganization?.defaults?.workflow_download_repo,
            workflow_download_branch: selectedOrganization?.defaults?.workflow_download_branch,
            notification_workflow: selectedOrganization?.defaults?.notification_workflow,
            documentation_reference: selectedOrganization?.defaults?.documentation_reference,
            workflow_upload_repo: selectedOrganization?.defaults?.workflow_upload_repo,
            workflow_upload_branch: selectedOrganization?.defaults?.workflow_upload_branch,
            workflow_upload_username: selectedOrganization?.defaults?.workflow_upload_username,
            workflow_upload_token: selectedOrganization?.defaults?.workflow_upload_token,
            newsletter: selectedOrganization?.defaults?.newsletter,
            weekly_recommendations: selectedOrganization?.defaults?.weekly_recommendations,
          },
          {
            sso_entrypoint: selectedOrganization?.sso_config?.sso_entrypoint,
            sso_certificate: selectedOrganization?.sso_config?.sso_certificate,
            client_id: selectedOrganization?.sso_config?.client_id,
            client_secret: selectedOrganization?.sso_config?.client_secret,
            openid_authorization: selectedOrganization?.sso_config?.openid_authorization,
            openid_token: selectedOrganization?.sso_config?.openid_token,
            SSORequired: selectedOrganization?.sso_config?.SSORequired,
            auto_provision: selectedOrganization?.sso_config?.auto_provision,
          },
          [],
        )
  };

  const imageInfo = (
    <img
      src={imageData}
      alt="Click to upload an image (174x174)"
      id="logo"
      style={{
        maxWidth: 174,
        maxHeight: 174,
        minWidth: 174,
        minHeight: 174,
        objectFit: "contain",
        borderRadius: 16,
      }}
    />
  );

  const errorText = imageUploadError.length > 0 ? (
    <div style={{ marginTop: 10 }}>Error: {imageUploadError}</div>
  ) : null;


  const imageUploadModalView = openImageModal ? (
    <Dialog
      open={openImageModal}
      onClose={onCancelSaveAppIcon}
      PaperProps={{
        sx: {
            borderRadius: theme?.palette?.DialogStyle?.borderRadius,
            border: theme?.palette?.DialogStyle?.border,
            minWidth: "300px",
            minHeight: "300px",
            fontFamily: theme?.typography?.fontFamily,
            backgroundColor: theme?.palette?.DialogStyle?.backgroundColor,
            zIndex: 1000,
            '& .MuiDialogContent-root': {
              backgroundColor: theme?.palette?.DialogStyle?.backgroundColor,
            },
            '& .MuiDialogTitle-root': {
              backgroundColor: theme?.palette?.DialogStyle?.backgroundColor,
            },
            '& .MuiDialogActions-root': {
              backgroundColor: theme?.palette?.DialogStyle?.backgroundColor,
            },
        },
    }}
    >
      <FormControl>
        <DialogTitle>
          <div style={{ color: theme?.palette?.textColor}}>Upload Organization Image</div>
        </DialogTitle>
        {errorText}
        <DialogContent style={{ color: theme?.palette?.textColor }}>
          <AvatarEditor
            ref={setEditorRef}
            image={croppedData}
            width={174}
            height={174}
            border={50}
            color={[0, 0, 0, 0.6]} // RGBA
            scale={scale}
            rotate={rotate}
            onImageChange={onPositionChange}
            onLoadSuccess={() => setRotation(0)}
          />
          <Divider style={dividerStyle} />
          <div style={{ display: "flex", justifyContent: "space-between", margin: "10px 0" }}>
            <Tooltip title="New Icon">
              <Button
                variant="outlined"
                component="label"
                style={appIconStyle}
                onClick={() => { upload.click(); }}
              >
                <AddAPhotoOutlinedIcon style={{ color: theme?.palette?.textColor }} />
              </Button>
            </Tooltip>
            <Tooltip title="Zoom In">
              <Button
                variant="outlined"
                component="label"
                style={appIconStyle}
                onClick={zoomIn}
              >
                <ZoomInOutlinedIcon style={{ color: theme?.palette?.textColor }} />
              </Button>
            </Tooltip>
            <Tooltip title="Zoom Out">
              <Button
                variant="outlined"
                component="label"
                style={appIconStyle}
                onClick={zoomOut}
              >
                <ZoomOutOutlinedIcon style={{ color: theme?.palette?.textColor }} />
              </Button>
            </Tooltip>
            <Tooltip title="Rotate">
              <Button
                variant="outlined"
                component="label"
                style={appIconStyle}
                onClick={rotation}
              >
                <LoopIcon style={{ color: theme?.palette?.textColor }} />
              </Button>
            </Tooltip>
          </div>
          <Divider style={dividerStyle} />
        </DialogContent>
        <DialogActions>
          <Button
            style={{ borderRadius: "2px", fontSize: 16, textTransform: "none", color: theme?.palette?.textColor }}
            onClick={onCancelSaveAppIcon}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{ borderRadius: "2px", fontSize: 16, color: "#000000", backgroundColor: disableImageUpload ? "" : "#5a66af", textTransform: 'none' }}
            disabled={disableImageUpload}
            onClick={onSaveAppIcon}
            color="primary"
          >
            Upload
          </Button>
        </DialogActions>
      </FormControl>
    </Dialog>
  ) : null;


  return (
    <div>
      <div
        style={{
          color: "black",
          flex: "1",
          display: "flex",
          flexDirection: "row",
          borderRadius: 16
        }}
      >
        <Tooltip title="Click to edit the organization's image (174x174)" placement="bottom">
          <div
            style={{
              margin: 10,
              cursor: "pointer",
              // backgroundColor: inputColor,
              maxWidth: 174,
              maxHeight: 174,
              borderRadius: 16,
            }}
            onClick={() => {
              setOpenImageModal(true);
            }}
          >
            <input
              hidden
              type="file"
              ref={(ref) => (upload = ref)}
              onChange={(e) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                  setCroppedData(event.target.result);
                };
                reader.readAsDataURL(e.target.files[0]);
              }}
            />
            {imageInfo}
          </div>
          {imageUploadModalView}
        </Tooltip>
        <div style={{ marginLeft: 16, alignContent: "center" }}>
          <div >
            <Button
              style={{ fontSize: 16, textTransform: 'capitalize',  boxShadow: "none", borderRadius: 4, width: 128, height: 40 }}
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenImageModal(true);
              }}
            >
              {file === null ? "Upload" : "Update"}
            </Button>
          </div>
          <div>
            <Button
              variant="contained"
              color="secondary"
              style={{ fontSize: 16, textTransform: 'capitalize', boxShadow: "none", marginTop: 20, borderRadius: 4, width: 128, height: 40 }}
              onClick={() => removeImage()}
            >
              Remove
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgHeader;
